// src/helpers/fetchAndSetSettings.js  
import { getSettings } from "../api/settings";

export const fetchAndSetSettings = async (dispatch, competitionId) => {
    try {
        const fetchedSettings = await getSettings(competitionId);
        if (fetchedSettings) {
            dispatch({ type: 'UPDATE_SETTINGS', payload: fetchedSettings });
        }
    } catch (error) {
        console.error('Error fetching settings:', error);
    }
};  
